import { Pipe, PipeTransform } from '@angular/core';
import { DateRange } from './ui-date-range.component';

const userDateFormat = 'DD.MM.YYYY';

@Pipe({
    name: 'clnDateRange',
})
export class DateRangePipe implements PipeTransform {

    transform(value?: DateRange): any {
        if (!value || !value.start || !value.end) {
            return '';
        }

        return `${value.start.format(userDateFormat)}-${value.end.format(userDateFormat)}`;
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/calendar/ui-date-range/date-range.pipe.ts